import React from 'react'
import { NavLink } from 'react-router-dom';
import './../Components/Error/Error.css'

const Error404 = () => {
    return (
        <div>
            <div id="notfound">
                <div className="notfound">
                    <div className="notfound-404">
                        <h1>404</h1>
                    </div>
                    <h2>We Are Sorry, PAGE NOT FOUND</h2>
                    <p>
                        THE PAGE YOU ARE LOOKING FOR MIGHT HAVE BEEN REMOVED OR ITS NAME CHANGED OR TYPE INCORRECT.
                    </p>
                    <NavLink to="/">Back to Homepage</NavLink>
                </div>
            </div>
        </div>
    )
}

export default Error404
